import type { PhotoResponse } from './photos';

export interface ServiceResponse {
  id: string;
  vendorId: string;
  vendorName: string;
  serviceTypeId: string;
  serviceCategoryId: string;
  serviceSubCategoryId: string;
  organizationId?: string;
  name: string;
  description?: string;
  notes?: string;
  isActive: boolean;
  photos?: PhotoResponse[];
  createdAt: string;
  updatedAt: string;
}

export interface ServiceOptionResponse {
  id: string;
  name?: string;
  description?: string;
  targetAudience: TargetAudience;
  pricingModel: PricingModel;
  notes?: string;
  basePrice?: number;
  currency?: string;
  duration?: number;
  minCapacity?: number;
  maxCapacity?: number;
  discountType?: DiscountType;
  discountValue?: number;
  claimLimit?: ClaimLimit;
  claimFrequency?: ClaimFrequency;
  isActive: boolean;
  sortOrder: number;
  photos?: PhotoResponse[];
  createdAt: string;
  updatedAt: string;
  service?: ServiceResponse;
  // Computed helper properties
  vendorName?: string; // This should be service.vendorName
  serviceName?: string; // This should be service.name
  durationMinutes?: number; // Alias for duration
  includedItems?: string[]; // Not in API, but used in UI
}

export enum TargetAudience {
  Individual = 'Individual',
  Company = 'Company',
  Both = 'Both'
}

export enum PricingModel {
  Fixed = 'Fixed',
  PerPerson = 'PerPerson',
  Discount = 'Discount',
  Benefit = 'Benefit'
}

export enum DiscountType {
  Percentage = 'Percentage',
  FixedAmount = 'FixedAmount'
}

export enum ClaimLimit {
  PerEmployee = 'PerEmployee',
  PerCompany = 'PerCompany',
  Unlimited = 'Unlimited'
}

export enum ClaimFrequency {
  Once = 'Once',
  Daily = 'Daily',
  Monthly = 'Monthly',
  Yearly = 'Yearly'
}

export interface Service extends ServiceResponse {
  options?: ServiceOptionResponse[];
}

export interface CreateServiceRequest {
  vendorId: string;
  serviceTypeId: string;
  serviceCategoryId: string;
  serviceSubCategoryId: string;
  organizationId?: string;
  name: string;
  description?: string;
  notes?: string;
  isActive: boolean;
}

export interface UpdateServiceRequest {
  serviceCategoryId: string;
  serviceSubCategoryId: string;
  organizationId?: string;
  name: string;
  description?: string;
  notes?: string;
  isActive: boolean;
}

export interface CreateServiceOptionRequest {
  name: string;
  description?: string;
  targetAudience: TargetAudience;
  pricingModel: PricingModel;
  notes?: string;
  basePrice?: number;
  currency?: string;
  duration?: number;
  minCapacity?: number;
  maxCapacity?: number;
  discountType?: DiscountType;
  discountValue?: number;
  claimLimit?: ClaimLimit;
  claimFrequency?: ClaimFrequency;
  isActive: boolean;
  sortOrder: number;
}

export interface UpdateServiceOptionRequest {
  name: string;
  description?: string;
  targetAudience: TargetAudience;
  pricingModel: PricingModel;
  notes?: string;
  basePrice?: number;
  currency?: string;
  duration?: number;
  minCapacity?: number;
  maxCapacity?: number;
  discountType?: DiscountType;
  discountValue?: number;
  claimLimit?: ClaimLimit;
  claimFrequency?: ClaimFrequency;
  isActive: boolean;
  sortOrder: number;
}